module.exports = __webpack_public_path__ + "static/sidemail-dfc7b720725d1608f2524aa985fa932d.jpg";